"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _ModalContext = require("../context/ModalContext");

var UIDialogHeaderImage = function UIDialogHeaderImage(props) {
  var className = props.className,
      offsetBottom = props.offsetBottom,
      offsetTop = props.offsetTop,
      style = props.style,
      rest = (0, _objectWithoutProperties2.default)(props, ["className", "offsetBottom", "offsetTop", "style"]);

  var _useContext = (0, _react.useContext)(_ModalContext.ModalContext),
      headerCallback = _useContext.headerCallback;

  var elRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    var updateHeaderOffset = function updateHeaderOffset() {
      // Measuring offsetTop in the DOM is more accurate than using the offsetTop prop, because it
      // accounts for the padding above the element.
      var overflow = -1 * elRef.current.offsetTop;

      if (overflow > 0) {
        headerCallback(overflow);
      }
    };

    updateHeaderOffset();
    addEventListener('resize', updateHeaderOffset);
    return function () {
      removeEventListener('resize', updateHeaderOffset);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return _react.default.createElement("div", (0, _extends2.default)({}, rest, {
    className: (0, _classnames.default)('private-modal__header-image', className),
    ref: elRef,
    style: (0, _extends2.default)({
      marginBottom: offsetBottom,
      marginTop: offsetTop != null && offsetTop * -1
    }, style)
  }));
};

UIDialogHeaderImage.propTypes = {
  children: _propTypes.default.node,
  offsetBottom: _propTypes.default.number,
  offsetTop: _propTypes.default.number
};
UIDialogHeaderImage.displayName = 'UIDialogHeaderImage';
var _default = UIDialogHeaderImage;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3722/js/dialog/UIDialogHeaderImage.js
// module id = 471
// module chunks = 5 6